import { render } from "./ModalAddPlayer.vue?vue&type=template&id=db080bd0"
import script from "./ModalAddPlayer.vue?vue&type=script&lang=js"
export * from "./ModalAddPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__